module.exports = __webpack_public_path__ + "img/avod.33262526.png";